export const ITEMS_PER_PAGE = 10;
export const ITEMS_PER_PAGE_STUD = 25;
export const ITEMS_PER_PAGE_FOR_GRID = 9;
export const ITEMS_PER_PAGE_COMPACT = 5;
export const ITEMS_PER_GRID_PAGE = 10;
export const DB_CONSTRAINT_MSG = 'Cannot delete this record as there are dependencies';
export const ITEMS_PER_PAGE_ALL = 100;
export const PAGE_SIZE = 3;
export const ITEMS_PER_PAGE_FOR_ATTENDANCE = 5;